import { useEffect, useState } from "react";

const CategoriesFlexRentCodes = {
    CarCloud: '18',
    FlexRent: '3',
    BeFree: '4',
    CarBox: '9',
  };
  
const categoryValueMappings = {
    [CategoriesFlexRentCodes.CarCloud]: '12',
    [CategoriesFlexRentCodes.FlexRent]: '6',
    [CategoriesFlexRentCodes.BeFree]: '24',
    [CategoriesFlexRentCodes.CarBox]: '12',
};


const useCategoriesFlexRent = (categories:any) => {
    const [mappedCategory,setMappedCategories] = useState<Map<string,string>>(new Map());
    useEffect(() => {
        if (categories && categories.length > 0 && mappedCategory.size === 0) {
        const newMappedCategories = new Map();
        categories.forEach((el:any) => {
            const value = categoryValueMappings[el.categoryCode];
            if (value !== undefined) {
            newMappedCategories.set(el.categoryCode, value);
            }
        });
        setMappedCategories(newMappedCategories);
        }
    }, [categories]);


    return mappedCategory

}
export default useCategoriesFlexRent;

